module.exports = __webpack_public_path__ + "img/casantino-py.8452710f.jpg";